import { cellRuleDirections } from './cellRuleDirections';
import { CellActions } from './cellActions';

const getExchangeCell = (exchanges, type) => {
  const item = exchanges?.find((ex) => ex.order_type === type);

  if (!item) return '—';

  const pair =
    item.left_asset && item.right_asset
      ? `${item.left_asset}/${item.right_asset}`
      : '—';

  return (
    <div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
      {item.exchange}
      <br />
      {pair}
    </div>
  );
};

const findNetwork = (exchanges) =>
  exchanges?.find((ex) => !('order_type' in ex) || ex.order_type === '');

const getNetworkCell = (exchanges) => {
  const item = findNetwork(exchanges);

  if (!item) return '—';

  return (
    <div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
      {item.network}
    </div>
  );
};

const findPmin = (exchanges) =>
  exchanges?.find((ex) => !('order_type' in ex) || ex.order_type === '');

const getPminCell = (exchanges) => {
  const item = findPmin(exchanges);

  if (!item) return '—';

  return (
    <div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
      {item.pmin}
    </div>
  );
};

const findDexExchange = (exchanges) =>
  exchanges?.find((ex) => !('order_type' in ex) || ex.order_type === '');

const getDexExchangeCell = (exchanges) => {
  const item = findDexExchange(exchanges);

  if (!item) return '—';

  return (
    <div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
      {item.exchange}
      <br />
      {item.left_asset}/{item.right_asset}
      <br />
    </div>
  );
};

export const getColumns = (handleActionClick) => [
  {
    field: 'id',
    headerName: 'ID',
    width: 80,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'enabled',
    headerName: 'Actions',
    renderCell: (cellValue) => {
      return CellActions(cellValue, handleActionClick);
    },
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'rule_directions',
    headerName: 'Direction',
    renderCell: ({ row: { rule_directions, id } }) => {
      return cellRuleDirections(rule_directions, id);
    },
    minWidth: 160,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'type',
    headerName: 'Type',
    minWidth: 130,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'limit',
    headerName: 'Limit (Exch / Pair)',
    minWidth: 200,
    headerAlign: 'center',
    rowHeight: 80,
    align: 'center',
    renderCell: ({ row }) => getExchangeCell(row.rule_exchanges, 'LIMIT'),
  },
  {
    field: 'market',
    headerName: 'Market (Exch / Pair)',
    minWidth: 200,
    headerAlign: 'center',
    align: 'center',
    renderCell: ({ row }) => getExchangeCell(row.rule_exchanges, 'MARKET'),
  },
  {
    field: 'dex',
    headerName: 'DEX (Exch / Pair)',
    minWidth: 200,
    headerAlign: 'center',
    align: 'center',
    renderCell: ({ row }) => getDexExchangeCell(row.rule_exchanges),
  },
  {
    field: 'network',
    headerName: 'Network',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    renderCell: ({ row }) => getNetworkCell(row.rule_exchanges),
  },
  {
    field: 'pmin',
    headerName: 'PMin',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    renderCell: ({ row }) => getPminCell(row.rule_exchanges),
  },
];
